import * as d3 from 'd3';
// import _ from 'lodash';

import { getSectionData, getStartEndDate } from '../utils/chart-utils';

// This is where functions for the scrollytelling live

// a reference to the default graphic container, change if needed
const container = d3.select('.chart-container');

import data from '../../../data/data.json'; // data

let weeklyDataSections = getSectionData(data);

let breakPoint = 544;

let duration = 600;

let colors = {
  highlight: '#348094',
  gray: '#f3f3f3',
  statewide: '#f3f3f3',
  totals: '#82c7d9',
};

let margin = { top: 40, bottom: 25, right: 25, left: 33 };


let dateStart, dateEnd;

dateStart = new Date('2020-03-18T00:00:00-05:00');

dateEnd = getStartEndDate(
  weeklyDataSections,
  'last',
  'Spring2021Chart',
  'end_date'
);

function fadeOutTitle(div, text) {
  const title = document.getElementsByClassName(div);

  title[0].innerHTML = text;

  title[0].classList.add('fade_out');
}

// Fade out chart title text

function RemovefadeOutTitle(div, text) {
  const title = document.getElementsByClassName(div);

  title[0].innerHTML = text;

  title[0].classList.remove('fade_out');
}

function fadeInTitle(div, text) {
  const title = document.getElementsByClassName(div);

  title[0].innerHTML = text;

  title[0].classList.add('fade_in');
}

// Fade out chart title text

function RemovefadeInTitle(div, text) {
  const title = document.getElementsByClassName(div);

  title[0].innerHTML = text;

  title[0].classList.remove('fade_in');
}

function FadeStepChartHighlight(highlight) {

  const all_paths = d3.selectAll('.path-fill');

  if (highlight == 'all') {
    all_paths
      .transition()
      .duration(duration)
      .style('fill', colors['highlight'])
      .style('opacity', 1);
  } else {

    all_paths
      .transition()
      .duration(duration)
      .style('fill', colors['gray'])
      .style('opacity', 0.8);

    all_paths
      .filter('.' + highlight)
      .transition()
      .duration(duration)
      .style('fill', colors['highlight'])
      .style('opacity', 1);
  }
}

function getYscale(max, height) {
  var y = d3.scaleLinear().domain([0, max]).range([height, 0]);

  return y;
}

function getXscale(date_range, width) {
  var x = d3.scaleTime().domain(date_range).range([0, width]);

  return x;
}

function createFillSegments(segmented_data, height, scale, y, x) {
  if (scale == 'zero') scale = 0;
  else scale = scale;

  const array = [];

  segmented_data.forEach((section_data) => {
    let deathWeeks = section_data.deathWeeks;

    let fill = `M${x(d3.min(deathWeeks, d => d['date'])) - 0.7},${height}`;

    deathWeeks.forEach((d, i) => {
      let y0;
      if (scale == 0) y0 = y(0);
      else y0 = y(d[scale]);

      let x0 = x(d.end_date);

      fill += `V${y0}H${x0}`;
    });

    fill += `V${height}Z`;

    array.push(fill);
  });

  return array;
}

function createStackedFillSegments(
  segmented_data,
  height,
  scale,
  y,
  x,
  type,
  section
) {
  if (scale == 'zero') scale = 0;
  else scale = scale;

  const array = [];

  // Get the keys for the stacked key chart

  let keys = getKeysforStackedChart(type, segmented_data[0].deathWeeks[0]);

  keys = keys.reverse();

  segmented_data.forEach((section_data) => {
    let deathWeeks = section_data.deathWeeks;

    // Get stacked values for each bar

    let stackedDataBreakdown = d3.stack().keys(keys)(deathWeeks);

    let fill = `M${x(d3.min(deathWeeks, d => d['date'])) - 0.7},${height}`;

    stackedDataBreakdown.forEach((each_data, index) => {
      each_data.forEach((d, i) => {
        let x0 = x(d.data.end_date);

        if (index == 0 && section == 'bottom_section') {
          let y0 = y(d[1]);
          fill += `V${y0}H${x0}`;
        }
        if (index == 1 && section == 'top_section') {
          let y0 = y(d[1]);
          fill += `V${y0}H${x0}`;
        }
      });
    });

    fill += `V${height}Z`;

    array.push(fill);
  });

  return array;
}

function createAnimation(y_scale, highlight, animate) {
  // We need to remove the bottom section of the stacked bar chart

  // d3.selectAll('.bottom-section').remove()

  let frameWidth = d3.select('.chart-container').node().offsetWidth;

  let height, max_scale;


  if (frameWidth > breakPoint) height = 450 - margin.top - margin.bottom;
  else height = 435 - margin.top - margin.bottom;

  let width = frameWidth - margin.left - margin.right;


  if (Number.isInteger(y_scale)) max_scale = y_scale;
  else max_scale = d3.max(data['weekly_data'], d => d[y_scale]) + margin.bottom;

  let y = getYscale(max_scale, height);

  let x = getXscale([dateStart, dateEnd], width);

  let new_path = createFillSegments(weeklyDataSections, height, y_scale, y, x);

  if (animate == true) {
    d3.select('.chart-container')
    .selectAll('.path-fill')
    .each(function (d, i) {
      if (this.classList[1] === highlight) {
        d3.select(this)
          .transition()
          .duration(duration)
          .style('fill', colors['highlight'])
          .style('opacity', 1)
          .attr('d', new_path[i]);
      } else {
        d3.select(this)
          .transition()
          .duration(duration)
          .style('fill', colors['gray'])
          .style('opacity', 1)
          .attr('d', new_path[i]);
      }
    });
  }
  else if (animate == false) {

    let g = d3.selectAll('.bar-chart-chart-group');
    d3.select('.chart-container')
    .selectAll('.path-fill')
    .each(function (d, i) {
        d3.select(this).remove()

       var new_bar = g.append('path')
          .attr('class', `path-fill ${this.classList[1]}`)
          .attr('d', new_path[i])
          .style('fill', colors['gray'])

      if (this.classList[1] == highlight) {
        new_bar.transition()
      .duration(duration)
      .style('fill', colors['highlight'])

      }


      
     
    });
  }

  
}

function createStackedAnimation(y_scale, type) {
  // Get zero fill with x-axis

  // We need height, x and y axis

  let frameWidth = d3.select('.chart-container').node().offsetWidth;

  let height, max_scale;

  if (frameWidth > breakPoint) height = 450 - margin.top - margin.bottom;
  else height = 435 - margin.top - margin.bottom;

  let width = frameWidth - margin.left - margin.right;

  if (Number.isInteger(y_scale)) max_scale = y_scale;
  else max_scale = d3.max(data['weekly_data'], d => d[y_scale]) + margin.bottom;

  let y = getYscale(max_scale, height);

  let x = getXscale([dateStart, dateEnd], width);

  let new_path_top = createStackedFillSegments(
    weeklyDataSections,
    height,
    y_scale,
    y,
    x,
    type,
    'top_section'
  );

  let new_path_bottom = createStackedFillSegments(
    weeklyDataSections,
    height,
    y_scale,
    y,
    x,
    type,
    'bottom_section'
  );

  // This is just to use to animate so that the bottom section doesn't suddenly appear

  let new_path_old = createFillSegments(
    weeklyDataSections,
    height,
    'zero',
    y,
    x
  );

  let g = d3.selectAll('.bar-chart-chart-group');

  d3.selectAll('.bottom-section').remove();

  if (type == 'totals_stacked') {

    d3.select('.chart-container')
      .selectAll('.path-fill')
      .each(function (d, i) {
        d3.select(this)
          .transition()
          .duration(duration)
          .style('fill', colors['highlight'])
          .attr('d', new_path_top[i]);


        g.append('path')
          .attr('class', 'path-fill bottom-section')
          .style('fill', colors['totals'])
          .attr('d', new_path_old[i])
          .transition()
          .duration(duration)
          .attr('d', new_path_bottom[i]);
      });

    // d3.selectAll('.bottom-section').each(function(d,i){

    //   d3.select(this)
    //   .transition().duration(duration)
    //         .attr('d', new_path_bottom[i])

    // });
  } else if (type == 'percent_stacked') {
    d3.select('.chart-container')
      .selectAll('.path-fill')
      .each(function (d, i) {
        d3.select(this)
          .transition()
          .duration(duration)
          .style('fill', colors['statewide'])
          .style('opacity', 1)
          .attr('d', new_path_top[i]);

        g.append('path')
          .attr('class', 'path-fill bottom-section')
          .style('fill', colors['highlight'])
          .attr('d', new_path_old[i])
          .transition()
          .duration(duration)
          .attr('d', new_path_bottom[i]);

        // d3.select(this)
        // .style("opacity", 0)
        // .attr('d', new_path_top[i])
        //   .transition().duration(400)
        //   .style("fill", colors['statewide']).style("opacity", 0.8)
      });

    // d3.selectAll('.bottom-section').each(function(d,i){

    //     d3.select(this)
    //     .transition().duration(50)
    //     .attr('d', new_path_old[i])
    //     .style("fill", colors['totals']).style("opacity", 0.8)
    //     .transition().duration(duration)
    //     .attr('d', new_path_bottom[i]);

    // });
  }
}

function getKeysforStackedChart(type, data) {
  let keys;

  if (type == 'totals_stacked') {
    keys = Object.keys(data)
      .slice(1)
      .filter(
        key => key == 'not_new_deaths' || key == 'weekly_deaths_reported'
      );
  } else if (type == 'percent_stacked') {
    keys = Object.keys(data)
      .slice(1)
      .filter(
        key => key == 'pct_of_total_deaths' || key == 'pct_non_nursing_homes'
      );
    keys = keys.reverse();
  }

  return keys;
}

function changeClassNamesChart(section, part, type) {
  let chart = document.querySelector('.timeline-chart');
  chart.removeAttribute('class');
  chart.className = `timeline-chart ${section} ${part} ${type}`;
}

function changeAxisScale(y_scale) {


  let frameWidth = d3.select('.chart-container').node().offsetWidth;

  let height;

  let max_scale;

  if (Number.isInteger(y_scale)) max_scale = y_scale;
  else max_scale = d3.max(data['weekly_data'], d => d[y_scale]) + margin.bottom;

  if (frameWidth > breakPoint) height = 450 - margin.top - margin.bottom;
  else height = 435 - margin.top - margin.bottom;

  let width = frameWidth - margin.left - margin.right;

  let y = getYscale(max_scale, height);


  // Honestly not sure why we have to add margin.bottom to scale. All I know is that if we don't, it's not the same size as the initial one

  let g = d3.select('g.axis--y');

  let yAxis = g =>
    g
      .attr('transform', `translate(0,0)`)
      .call(d3.axisLeft(y).ticks(5).tickSize(-width).tickFormat(customYFormat));


  g.transition().duration(duration).call(yAxis);

  function customYFormat(d) {
    if (d === 0) return '';
    else if (Number.isInteger(y_scale)) return d + '%';
    else return d3.format(',')(d);
  }
}

export {
  fadeOutTitle,
  RemovefadeOutTitle,
  fadeInTitle,
  RemovefadeInTitle,
  FadeStepChartHighlight,
  changeAxisScale,
  createAnimation,
  createStackedAnimation,
  createFillSegments,
  changeClassNamesChart,
};
